import React = require("react");
import { ready } from "../../../../custom_api/api_utils"
import { AdviceSortMethod, adviceSortMethods, AdviceType } from "../../../../custom_api/bookarang/types"
import { pushInspirationAction } from "../../datalayer"
import { JumboKiosk } from "../../Kiosk/JumboKiosk"
import { Link } from "../../library/link"
import { promptUrl } from "../InspirationRoutes"
import { InspirationBaseSelector, inspirationLabelsKiosk } from "../Shared/InspirationBaseSelector"
import { jumboText } from "../Shared/InspirationUtils"
import { Advice } from "./Advice"
import { AdviceDetails } from "./AdviceDetails"
import { AdviceLayoutProps } from "./AdviceState"
import { Filters } from "./FilterSelector/FilterSelector"
import { sortLabels } from "./FilterSelector/FilterSelectorState"
import { CollectionItem } from "../../../../../Shared/backendApi/generated";
import { AsyncState } from "widgets-for-react";

export const AdviceLayoutKiosk = (props: AdviceLayoutProps) => {
  const { adviceType, selectedPrompt, advice, filters, updateFilterValue, sortMethod,
    updateSortMethod, title, author, routePath, highlight, setHighlight, resetHighlight, selectedBook } = props

  return (
    <div className="advice-page ip ip--kiosk" key="AdviceLayout">
      <JumboKiosk
        {...jumboText[adviceType]}
        size="small"
        isFixed={true}
      />
      <div className="ip__content advice">

        {highlight && <AdviceDetails {...highlight} close={() => resetHighlight()} />}

        <div className={`layout layout--sc-ip layout--${adviceType}`}>
          <div className="layout__top">
            {adviceType == 'book' && selectedBook.kind == 'loaded' && resultBook(selectedBook.value, setHighlight)}
            {advice.kind == 'loading' && <div className="book__preview"><p>Resultaten worden geladen...</p></div>}
            <div className="layout__header ip__header--tools">
              <div className="layout__title">
                <Link url={promptUrl(routePath, adviceType)} className="layout__header-link" title="Terug">
                  <svg className="layout__header-link-icon" width="16" height="42" aria-hidden="true"><use xlinkHref="#icon--chevron-right" /></svg>
                </Link>
                {advice.kind == 'loaded'
                  ? resultTextSection(adviceType, selectedPrompt, advice.value.length, selectedBook)
                  : <p>Resultaten worden geladen...</p>
                }
              </div>

              <div className="ip__tools">
                <div className="ip__sort form__select">
                  <select id="form-select-filter" value={sortMethod} onChange={(e) => updateSortMethod(e.target.value as AdviceSortMethod)}>
                    {adviceSortMethods.map((method: AdviceSortMethod) => {
                      return <option key={`${method}_sort_method_option`} value={method}>{sortLabels[method]}</option>
                    })}
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="layout__content">
            {ready(advice) && <Advice
              advice={advice.value}
              state={advice.kind}
              urlFrom={b => `?title=${title}&author=${author}`}
              handlerFrom={b => () => {
                pushInspirationAction(adviceType, "Bekijk details geadviseerd boek in Kiosk", `${b.title} - ${b.author}`)
                setHighlight(b.id)
              }}

            />}
          </div>

          {adviceType == 'book' ? <></> :
            <div className="layout__sidebar">
              {(ready(filters) && filters.value.length > 0) ?
                <div className="ip__filter">
                  <div id="a11y-tbi-filter" className="ip__filter-content" aria-hidden="false">
                    <div className="ip__filter-inner">
                      <div className="layout__header ip__header--filter">
                        <h2 className="layout__title title--s">Verfijn resultaten</h2>
                      </div>
                      <Filters filters={filters.value} updateFilterValue={updateFilterValue} />
                    </div>
                  </div>
                </div>
                :
                <div className="ip__filter">
                  <p>Er zijn geen filters gevonden voor <strong>{selectedPrompt}</strong>.</p>
                </div>
              }
            </div>
          }
        </div>

      </div>
      <InspirationBaseSelector activeBase={adviceType} routePath={routePath} labels={inspirationLabelsKiosk} />
    </div>)
}
const resultBook = (selectedBook: CollectionItem, setHighlight: (id: string) => void) => {
  const { shortDescription, authors, title, imageUrls, OriginalId } = selectedBook
  return <Link
    title={`${title} - ${authors?.[0]}`}
    url='#'
    handle={() => {
      pushInspirationAction('book', "Bekijk details gekozen startboek in Kiosk", `${title} - ${authors?.[0]}`)
      setHighlight(OriginalId)
    }}
    className={`book__preview--link`}
  ><div className="book__preview">
      <div className="book__preview--inner">
        <div className="book__preview--left">
          <img src={imageUrls?.w245} alt={title} />
        </div>
        <div className="book__preview--content">
          <div className="book__preview--eyebrow">Startboek</div>
          <h2>{title}</h2>
          <div className="book__preview--author">{authors?.[0]}</div>
          <p>{shortDescription}</p>
        </div>
      </div>
    </div>
  </Link>
}

const resultTextSection = (adviceType: AdviceType, selectedPrompt: string, amount: number, selectedBook: AsyncState<CollectionItem>) => {
  if (adviceType == 'book' && selectedBook.kind == "loaded")
    return <div className="layout__header-content">
      <p>Je hebt <strong>{selectedBook.value.title}</strong> van <strong>{selectedBook.value.authors?.[0]}</strong> gekozen als startboek.</p>
      <p>Hieronder zie je {amount} boeken die erop lijken.</p>
    </div>
  if (adviceType == 'mood')
    return <p>Je hebt gekozen voor <strong>{selectedPrompt}</strong>. Filter om bij een boek te vinden dat bij je past.</p>
  if (adviceType == 'theme')
    return <p>Je hebt <strong>{selectedPrompt}</strong> als onderwerp gekozen. Filter om een boek te vinden dat bij je past.</p>
}

